var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.view.isPrepared)?_c('router-view',{key:_vm.$route.fullPath}):_vm._e(),(_vm.checkEtcPopup)?_c('etc-popup',{attrs:{"popupSet":_vm.popupSet}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }